import { getPressReleasesFlat } from "@clients/afaseApiClient";
import { getMappedPressreleaseUrlStructure } from "@utils/mappers/pressreleaseUrlStructureMapper";
import { SiteCacheItem, siteCacheFetch } from "@utils/siteStructureCache";

import { UrlStructure } from "types/UrlStructure";

export const getPressreleaseUrlStructure = async (): Promise<UrlStructure> => {
  return siteCacheFetch(SiteCacheItem.PRESS_RELEASE_URL_STRUCTURE, async () => {
    const pressReleasesFlat = await getPressReleasesFlat();
    return { urls: getMappedPressreleaseUrlStructure(pressReleasesFlat) };
  });
};
